import { useEffect, useState } from "react";
import { Trash2, Check, Mail } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { ConfirmDelete } from "./ConfirmDelete";

export const AdminMessages = ({ onChange }) => {
  const [list, setList] = useState([]);
  const load = () => api.get("/admin/messages").then((r) => setList(r.data));
  useEffect(() => { load(); }, []);
  const mark = async (id) => { await api.patch(`/admin/messages/${id}`); load(); onChange?.(); };
  const remove = async (id) => { await api.delete(`/admin/messages/${id}`); toast.success("Messaggio eliminato"); load(); onChange?.(); };

  return (
    <div data-testid="admin-messages">
      <h2 className="font-display text-2xl font-bold uppercase tracking-tight mb-6">Messaggi & Demo</h2>
      {!list.length && <p className="text-sm text-zinc-400 border border-dashed border-white/15 p-10 text-center">Nessun messaggio ricevuto.</p>}
      <div className="space-y-3">
        {list.map((m) => (
          <div key={m.id} className={`border p-5 ${m.read ? "border-white/10 bg-[#0d0e12]" : "border-emerald-500/40 bg-emerald-500/5"}`} data-testid={`admin-message-${m.id}`}>
            <div className="flex flex-wrap items-start justify-between gap-3">
              <div>
                <p className="font-semibold">{m.name} <span className="font-mono-tga text-[10px] uppercase tracking-[0.2em] text-emerald-400 ml-2">{m.subject}</span></p>
                <a href={`mailto:${m.email}`} className="text-xs text-zinc-400 hover:text-emerald-400 inline-flex items-center gap-1"><Mail className="h-3 w-3" />{m.email}</a>
              </div>
              <div className="flex items-center gap-1">
                <span className="font-mono-tga text-[10px] text-zinc-500 mr-2">{new Date(m.created_at).toLocaleString("it-IT")}</span>
                {!m.read && <button onClick={() => mark(m.id)} className="p-2 text-zinc-400 hover:text-emerald-400" aria-label="Segna come letto" data-testid={`admin-mark-read-${m.id}`}><Check className="h-4 w-4" /></button>}
                <ConfirmDelete onConfirm={() => remove(m.id)} testid={`admin-delete-message-${m.id}`} title="Eliminare il messaggio?"><Trash2 className="h-4 w-4" /></ConfirmDelete>
              </div>
            </div>
            <p className="text-sm text-zinc-300 mt-3 whitespace-pre-line">{m.message}</p>
            {m.demo_link && <a href={m.demo_link} target="_blank" rel="noopener noreferrer" className="text-sm text-emerald-400 mt-2 inline-block break-all">{m.demo_link}</a>}
          </div>
        ))}
      </div>
    </div>
  );
};
